import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setHeaderName,
  setSubHeaderName,
} from "../../../../ReduxStore/Slices/headerSlice";
import {
  Backdrop,
  Box,
  Button,
  emphasize,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import CustomInputLogin from "../../../../Components/CustomInputLogin/CustomInputLogin";
import { Formik, Form } from "formik";
import CustomExcelUpload from "../../../../Components/CustomExcelUpload/CustomExcelUpload";
import { BackHandSharp, Upload } from "@mui/icons-material";
import { IoIosArrowRoundBack } from "react-icons/io";
import CustomTable from "../../../../Components/Table/CustomTable";
import actions from "../../../../ReduxStore/actions";
import CustomInputForm from "../../../../Components/CustomInputLogin/CustomInputForm";
import { toast, ToastContainer } from "react-toastify";
import CustomDropdownMui from "../../../../Components/CustomDropDown/CustomDropdown";
import CustomDateInput from "../../../../Components/CustomDate/CustomDateInput";
import SubDepartment from "../../Master/SubDepartment/SubDepartment";
import CustoDropDownRegister from "../../../../Components/CustomDropDown/CustoDropDownRegister";

import * as Yup from "yup";
import { adminUrl } from "../../../../constants";
import InvalidRowsModal from "../../../../Components/InvalidRowsModal/InvalidRowsModal";
import FullPageLoader from "../../../../Components/FullPageLoader/FullPageLoader";
import { bulkUploadEmployeeFromExcelAction } from "../../../../ReduxStore/Slices/AddEmployee/bulkUploadEmployeeFromExcel";

// const validationSchema = Yup.object().shape({
//     employeeid: Yup.number()
//         .typeError('Employee ID must be a number')
//         .required('Employee ID is required'),

//     employeename: Yup.string()
//         .required('Employee Name is required')
//         .matches(/^[a-zA-Z ]+$/, 'Only alphabets and spaces are allowed'),

//     dateofjoining: Yup.date()
//         .typeError('Invalid date')
//         .required('Date of Joining is required'),

//     email: Yup.string()
//         .email('Invalid email address')
//         .required('Email is required'),
// });
const validationSchema = Yup.object().shape({
  file: Yup.mixed().nullable(),

  // department: Yup.string()
  //     .trim()
  //     .when('file', {
  //         is: (file) => !file,
  //         then: (schema) => schema.required('Department is required'),
  //         otherwise: (schema) => schema.notRequired(),
  //     }),

  employeeid: Yup.number()
    .typeError("Employee ID must be a number")
    .when("file", {
      is: (file) => !file,
      then: (schema) => schema.required("Employee ID is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

  employeename: Yup.string()
    .matches(/^[a-zA-Z ]+$/, "Only alphabets and spaces are allowed")
    .when("file", {
      is: (file) => !file,
      then: (schema) => schema.required("Employee Name is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

  dateofjoining: Yup.date()
    .typeError("Invalid date")
    .when("file", {
      is: (file) => !file,
      then: (schema) => schema.required("Date of Joining is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

  email: Yup.string()
    .email("Invalid email address")
    .when("file", {
      is: (file) => !file,
      then: (schema) => schema.required("Email is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
  password: Yup.string()
    .min(4, "Password must be at least 4 characters")
    .when("file", {
      is: (file) => !file,
      then: (schema) => schema.required("Password is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
});

const validationSchema1 = Yup.object().shape({
  file: Yup.mixed().nullable(),

  // department: Yup.string()
  //     .trim()
  //     .when('file', {
  //         is: (file) => !file,
  //         then: (schema) => schema.required('Department is required'),
  //         otherwise: (schema) => schema.notRequired(),
  //     }),

  employeeid: Yup.number()
    .typeError("Employee ID must be a number")
    .when("file", {
      is: (file) => !file,
      then: (schema) => schema.required("Employee ID is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

  employeename: Yup.string()
    .matches(/^[a-zA-Z ]+$/, "Only alphabets and spaces are allowed")
    .when("file", {
      is: (file) => !file,
      then: (schema) => schema.required("Employee Name is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

  dateofjoining: Yup.date()
    .typeError("Invalid date")
    .when("file", {
      is: (file) => !file,
      then: (schema) => schema.required("Date of Joining is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

  email: Yup.string()
    .email("Invalid email address")
    .when("file", {
      is: (file) => !file,
      then: (schema) => schema.required("Email is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
});

const AddEmployee = () => {
  const dispatch = useDispatch();
  const [showExcelUpload, setShowExcelUpload] = useState(false); // State to toggle
  const tableHeadData = [
    "S.No",
    "Employee ID",
    "Name",
    "Email",
    "Department",
    "Sub Department",
    "Designation",
    "DOJ",
    "KRA & KPI",
    "Re-apply",
    "Actions",
  ];
  const tableData = [
    {
      employeeId: "384",
      department: "SALES",
      subdepartment: "SANITARYWARE",
      designation: "AASM - WATERTEC AQCETO",
      doj: "01 -08 - 2023",
      krakpi: "SALES EXECUTIVE - 3105",
      name: "D S MOHANAKUMAR NARAKULA",
    },
    {
      employeeId: "589",
      department: "SALES",
      subdepartment: "SANITARYWARE",
      designation: "AASM - WATERTEC AQCETO",
      doj: "01 -08 - 2023",
      krakpi: "SALES EXECUTIVE - 3105",
      name: "D S MOHANAKUMAR NARAKULA",
    },
    {
      employeeId: "077",
      department: "SALES",
      subdepartment: "SANITARYWARE",
      designation: "AASM - WATERTEC AQCETO",
      doj: "01 -08 - 2023",
      krakpi: "SALES EXECUTIVE - 3105",
      name: "D S MOHANAKUMAR NARAKULA",
    },
    {
      employeeId: "985",
      department: "SALES",
      subdepartment: "SANITARYWARE",
      designation: "AASM - WATERTEC AQCETO",
      doj: "01 -08 - 2023",
      krakpi: "SALES EXECUTIVE - 3105",
      name: "D S MOHANAKUMAR NARAKULA",
    },
    {
      employeeId: "0734",
      department: "SALES",
      subdepartment: "SANITARYWARE",
      designation: "AASM - WATERTEC AQCETO",
      doj: "01 -08 - 2023",
      krakpi: "SALES EXECUTIVE - 3105",
      name: "D S MOHANAKUMAR NARAKULA",
    },
  ];
  const [uploadType, setUploadType] = useState("AddEmployee");

  useEffect(() => {
    dispatch(setHeaderName("Master"));
    dispatch(setSubHeaderName("Add Employee"));
  }, [dispatch]);
  const [editData, setEditData] = useState();

  useEffect(() => {
    const fetchData = async () => {
      const data1 = {
        data: {},
        method: "get",
        apiName: "getAllDepartments",
      };
      const responseData = dispatch(actions.GETALLDEPARTMENTS(data1));
      console.log(responseData, "responseData");
    };
    fetchData();
  }, []);

  const { getAllDepartments } = useSelector(
    (state) => state?.getAllDepartments
  );

  const departmentOptions = getAllDepartments?.data?.map((data) => ({
    value: data?.department_id,
    label: data?.department_name,
  }));

  const [subDepartmentNames, setSubDepartmentNames] = useState([]);
  // const [stateNames, setStateNames] = useState([]);
  // const [cityNames, setCityNames] = useState([]);

  // const [selectedCountryId, setSelectedCountryId] = useState(null);

  // Handle country selection
  const handleDepartmentChange = (selectedId) => {
    console.log("Selected department ID:", selectedId);

    // setSelectedCountryId(selectedId);
    setSubDepartmentNames([]); // Reset sub departments

    if (selectedId) {
      fetchSubDepartments(selectedId);
    }
  };
  // Fetch states based on selected country
  const fetchSubDepartments = async (department_id) => {
    const data = {
      data: {
        // country_id: countryId
      },
      method: "get",
      apiName: `getSubDepartmentsByDepartmentId/${department_id}`,
    };

    const response = await dispatch(
      actions.GETSUBDEPARTMENTSBYDEPARTMENTID(data)
    );

    if (
      response?.payload?.message === "All sub-departments fetched successfully."
    ) {
      const formattedStates =
        response?.payload?.data?.map((state) => ({
          label: state.sub_department_name,
          value: state.sub_department_id,
        })) || [];

      setSubDepartmentNames(formattedStates);
    }
  };

  useEffect(() => {
    if (editData?.department_id) {
      fetchSubDepartments(editData.department_id);
    }
  }, [editData?.department_id]);

  // Designation Dropdown data
  const { getAllDesignations } = useSelector(
    (state) => state?.getAllDesignations
  );
  console.log(getAllDesignations, "getAllDesignations");

  useEffect(() => {
    const fetchData = async () => {
      const data1 = {
        data: {},
        method: "get",
        apiName: "getAllDesignations",
      };
      const responseData = dispatch(actions.GETALLDESIGNATIONS(data1));
      console.log(responseData, "responseData");
    };
    fetchData();
  }, []);

  const designationOptions = getAllDesignations?.data?.map((data) => ({
    value: data?.designation_id,
    label: data?.designation_name,
  }));

  // Designation Dropdown data
  const { getAllEmployees } = useSelector((state) => state?.getAllEmployees);
  console.log(getAllDesignations, "getAllDesignations");

  const { updateEmployee } = useSelector((state) => state?.updateEmployee);
  const { createEmployee } = useSelector((state) => state?.createEmployee);
  const { toggleEmployeeStatus } = useSelector(
    (state) => state?.toggleEmployeeStatus
  );
  const { rejectAppraisalReapply } = useSelector(
    (state) => state?.rejectAppraisalReapply
  );
  const { acceptAppraisalReapply } = useSelector(
    (state) => state?.acceptAppraisalReapply
  );
  const { bulkUploadEmployeeFromExcel } = useSelector(
    (state) => state?.bulkUploadEmployeeFromExcel
  );

  const managerOptions = getAllEmployees?.data?.map((data) => ({
    value: data?.employee_id,
    label: data?.employee_name,
  }));

  const { getAllKraKpi } = useSelector((state) => state?.getAllKraKpi);
  console.log(getAllKraKpi, "getAllKraKpi");

  const [invalidRowsModalopen, setInvalidRowsModalOpen] = useState(false);
  const [invalidRwModalResponseData, setInvalidRwModalResponseData] = useState(
    []
  );

  const handleInvalidRowsModalOpen = () => {
    setInvalidRowsModalOpen(true);
  };
  const handleInvalidRowsModalClose = () => {
    setInvalidRowsModalOpen(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      const data1 = {
        data: {},
        method: "get",
        apiName: "getAllKraKpi",
      };
      const responseData = dispatch(actions.GETALLKRAKPI(data1));
      console.log(responseData, "responseData");
    };
    fetchData();
  }, []);

  const roleofkrkpiOptions = getAllKraKpi?.data?.map((data) => ({
    value: data?.kra_kpi_id,
    label: data?.kra_kpi_name,
  }));
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values, { resetForm }) => {
    console.log(values, "values");
    if (values?.file === null) {
      setLoading(true);

      // const data1 = {
      //     data: {

      //         employee_code: values?.employeeid,
      //         employee_name: values?.employeename,
      //         department_id: values?.department,
      //         sub_department_id: values?.subdepartment,
      //         designation_id: values?.designation,
      //         kra_kpi_id: values?.roleofkrkpi,
      //         reporting_manager_id: values?.reportingmanager,
      //         reviewer_id: values?.reviewer,
      //         date_of_joining: values?.dateofjoining,
      //         email: values?.email,
      //         password: values?.password
      //     },
      //     method: editData?.employee_id ? "put" : "post",
      //     apiName: editData?.employee_id ? `updateEmployee/${editData?.employee_id}` : "createEmployee"
      // };
      const employeeData = {
        employee_code: values?.employeeid,
        employee_name: values?.employeename,
        department_id: values?.department,
        sub_department_id: values?.subdepartment,
        designation_id: values?.designation,
        kra_kpi_id: values?.roleofkrkpi,
        date_of_joining: values?.dateofjoining,
        email: values?.email,
        // password: values?.password
      };

      // Conditionally add reporting_manager_id if it's not empty (null/undefined/'')

      if (values?.password) {
        employeeData.password = values?.password;
      }

      if (values?.reportingmanager) {
        employeeData.reporting_manager_id = values.reportingmanager;
      }

      // Conditionally add reviewer_id if needed
      if (values?.reviewer) {
        employeeData.reviewer_id = values.reviewer;
      }

      const data1 = {
        data: employeeData,
        method: editData?.employee_id ? "put" : "post",
        apiName: editData?.employee_id
          ? `updateEmployee/${editData?.employee_id}`
          : "createEmployee",
      };

      const responseData = await dispatch(
        editData?.employee_id
          ? actions.UPADATEEMPLOYEE(data1)
          : actions.CREATEEMPLOYEE(data1)
      );
      console.log(responseData, "responseData");
      if (responseData?.payload?.message === "Employee created successfully.") {
        setLoading(false);
        toast.success("Employee created successfully.");
        resetForm();
      } else if (
        responseData?.payload?.message === "Employee updated successfully."
      ) {
        setLoading(false);

        toast.success("Employee updated successfully.");
        setEditData();
        resetForm();
      } else {
        setLoading(false);

        toast.error(responseData?.payload?.message);
      }
    } else {
      setLoading(true);

      const formData = new FormData();
      formData.append("file", values?.file);

      console.log(formData, "formData");

      // Dynamically pick the API name
      let apiName = "";
      let apiMethod = "";
      if (uploadType === "AddEmployee") {
        apiName = "bulkUploadEmployeeFromExcel";
        apiMethod = "post";
        // actionName = "BULKUPLOADEMPLOYEEFROMEXCEL";
      } else if (uploadType === "UpdateEmployee") {
        apiName = "bulkUpdateEmployeeFromExcel";
        apiMethod = "put";
      } else if (uploadType === "ActivateDeactivate") {
        apiName = "bulkUpdateActiveDeactiveEmployeeFromExcel";
        apiMethod = "put";
      }

      const data1 = {
        data: formData,
        method: apiMethod,
        apiName: apiName, // ✅ dynamic
      };

      const responseData = await dispatch(
        uploadType === "AddEmployee"
          ? actions.BULKUPLOADEMPLOYEEFROMEXCEL(data1)
          : uploadType === "UpdateEmployee"
            ? actions.BULKUPDATEEMPLOYEEFROMEXCEL(data1)
            : uploadType === "ActivateDeactivate"
              ? actions.BULKUPDATEACTIVATEDEACTIVATEDEMPLOYEEFROMEXCEL(data1)
              : null
      );
      console.log(responseData, "responseData");

      if (
        (responseData?.payload?.message === uploadType) === "AddEmployee"
          ? "Bulk upload completed."
          : "Bulk update completed."
      ) {
        setLoading(false);
        setInvalidRwModalResponseData(responseData?.payload?.data);
        handleInvalidRowsModalOpen(true);

        resetForm();
      } else {
        setLoading(false);
        toast.error(responseData?.payload?.message);
      }
    }
  };
  const [rowTableData, setRowTableData] = useState([]);
  console.log(rowTableData, "rowTajerei");

  useEffect(() => {
    const tempArr = [];

    getAllEmployees?.data?.map((data, index) => {
      return tempArr.push({
        // id: data?.internship_id,
        employeeId: data?.employee_id,
        kra_kpi_answer_id: data?.kra_kpi_answer_id,

        employee_code: data?.employee_code || " N/A",
        employee_name: data?.employee_name || " N/A",
        email: data?.email || " N/A",
        department_name: data?.department?.department_name || " N/A",
        sub_department_name:
          data?.sub_department?.sub_department_name || " N/A",
        designation_name: data?.designation?.designation_name || " N/A",
        date_of_joining: data?.date_of_joining || " N/A",
        kra_kpi_name: data?.kra_kpi?.kra_kpi_name || " N/A",

        appraisal_reapply_status: data?.appraisal_reapply_status || " N/A",
        activeStatus: data?.is_active || " N/A",
        // pmsScoreEnable:"pmsScoreEnable"
      });
    });
    setRowTableData(tempArr);
  }, [getAllEmployees]);
  const handleTableEdit = async (id) => {
    setShowExcelUpload(false);
    window.scrollTo({ top: 0, behavior: "smooth" }); // Scroll to top

    console.log(id, "idgretoriut");
    const data1 = {
      data: {},
      method: "get",
      apiName: `getEmployeeById/${id}`,
    };
    const responseData = await dispatch(actions.GETALLEMPLOYEEBYID(data1));
    console.log(responseData, "getDesignationById");
    if (
      responseData?.payload?.message === "getEmployeeById fetched successfully."
    ) {
      setEditData(responseData?.payload?.data);
    }
  };

  const handleActivateAndDeactivate = async (activeStatus, id) => {
    setShowExcelUpload(false);
    console.log(id, "idgretoriut");
    const data1 = {
      data: {
        is_active: !activeStatus,
      },
      method: "patch",
      apiName: `toggleEmployeeStatus/${id}`,
    };
    const responseData = await dispatch(actions.TOGGLEEMPLOYEESTATUS(data1));
    console.log(responseData, "getDesignationById");
    if (
      responseData?.payload?.message === "Employee deactivated successfully" ||
      "Employee activated successfully"
    ) {
      toast.success(responseData?.payload?.message);
    } else {
      toast.error(responseData?.payload?.message);
    }
  };

  const authToken = localStorage.getItem("authToken");
  // const handleSamplDownload = async () => {
  //     try {

  //         if(uploadType==="AddEmployee"){
  //         const response = await fetch(`${adminUrl}downloadEmployeeSampleExcelFile`, {
  //             method: 'GET',
  //             headers: {
  //                 'Authorization': `Bearer ${authToken}`, // Replace with actual token
  //             }
  //         });
  //     }

  //         if (!response.ok) {
  //             throw new Error('Network response was not ok');
  //         }

  //         const blob = await response.blob();
  //         const url = window.URL.createObjectURL(blob);
  //         const a = document.createElement('a');
  //         a.href = url;
  //         a.download = 'Employee_Sample.xlsx'; // Set desired filename
  //         document.body.appendChild(a);
  //         a.click();
  //         a.remove();
  //         window.URL.revokeObjectURL(url);
  //     } catch (error) {
  //         console.error('Download failed:', error);
  //     }
  // };
  const handleSamplDownload = async () => {
    try {
      let endpoint = "";
      let filename = "";

      if (uploadType === "AddEmployee") {
        endpoint = `${adminUrl}downloadEmployeeSampleExcelFile`;
        filename = "Add_employee_Sample.xlsx";
      } else if (uploadType === "UpdateEmployee") {
        endpoint = `${adminUrl}downloadEmployeeUpdateSampleExcelFile`;
        filename = "Update_employee_Sample.xlsx";
      } else if (uploadType === "ActivateDeactivate") {
        endpoint = `${adminUrl}downloadEmployeeActiveStatusSampleExcelFile`;
        filename = "Activate_deactivate_Sample.xlsx";
      }

      if (!endpoint) return;

      const response = await fetch(endpoint, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${authToken}`, // Replace with actual token
        },
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename; // ✅ different filename for each type
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  const handleRequestReapplyAccept = async (id) => {
    setLoading(true);
    const data1 = {
      data: {},
      method: "put",
      apiName: `acceptAppraisalReapply/${id}`,
    };
    const responseData = await dispatch(actions.ACCEPTAPPRAISALREAPPLY(data1));
    if (
      responseData?.payload?.message ===
      "Reapply accepted. Employee score is now editable."
    ) {
      setLoading(false);
      toast.success("Request for reapply sent successfully");
    } else {
      setLoading(false);
      toast.error(responseData?.payload?.message);
    }
  };
  const handleRequestReapplyReject = async (id) => {
    setLoading(true);
    const data1 = {
      data: {},
      method: "put",
      apiName: `rejectAppraisalReapply/${id}`,
    };
    const responseData = await dispatch(actions.REJECTAPPRAISALREAPPLY(data1));
    if (responseData?.payload?.message === "Reapply requested successfully.") {
      setLoading(false);
      toast.success("Request for reapply sent successfully");
    } else {
      setLoading(false);
      toast.error(responseData?.payload?.message);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const data1 = {
        data: {},
        method: "get",
        apiName: "getAllEmployees",
      };
      const responseData = dispatch(actions.GETALLEMPLOYEES(data1));
      console.log(responseData, "responseData");
    };
    fetchData();
  }, [
    dispatch,
    createEmployee,
    updateEmployee,
    toggleEmployeeStatus,
    acceptAppraisalReapply,
    rejectAppraisalReapply,
    bulkUploadEmployeeFromExcel,
  ]);

  return (
    <Box>
      {loading && <FullPageLoader />}
      <Box
        sx={{
          background: "white",
          p: 3,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            variant="subtitle2"
            sx={{ color: "black", fontSize: "18px" }}
          >
            {showExcelUpload ? "Upload Excel" : "Add Employee"}
          </Typography>
          <Typography
            variant="body1"
            onClick={() => setShowExcelUpload(!showExcelUpload)}
            sx={{
              textAlign: "end",
              color: "var(--main-color)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
            }}
          >
            {showExcelUpload ? (
              <IoIosArrowRoundBack style={{ mr: 1, fontSize: "25px" }} />
            ) : (
              <Upload sx={{ mr: 1 }} />
            )}
            {showExcelUpload ? "Back to Form" : "Upload Excel"}
          </Typography>
        </Box>

        <Formik
          enableReinitialize
          initialValues={{
            department: editData?.department_id || "",
            employeeid: editData?.employee_code || "",
            employeename: editData?.employee_name || "",
            dateofjoining: editData?.date_of_joining || "",
            subdepartment: editData?.sub_department_id || "",
            designation: editData?.designation_id || "",
            reportingmanager: editData?.reporting_manager_id || "",
            reviewer: editData?.reviewer_id || "",
            roleofkrkpi: editData?.kra_kpi_id || "",
            password: "",
            email: editData?.email || "",

            file: null,
          }}
          validationSchema={
            editData?.employee_id ? validationSchema1 : validationSchema
          }
          onSubmit={handleSubmit}
        >
          {({
            errors,
            touched,
            handleChange,
            values,
            setFieldValue,
            resetForm,
          }) => (
            <Form>
              <Grid container spacing={2} mt={2}>
                {/* <Grid item size={{ xs: 12, md: 12 }}> */}
                {showExcelUpload ? (
                  <>
                    <Grid item size={{ xs: 12 }}  sx={{padding:2}}>
                      <Grid item size={{ xs: 12, md: 6 }}>
                        {/* Dropdown */}
                        <FormControl fullWidth size="small">
                          {/* <InputLabel>Upload Type</InputLabel> */}
                          <Typography
                            variant="subtitle1"
                            sx={{
                              color: "gray",
                              fontSize: "15px",
                              mb: 1,
                            }}
                          >
                            Upload Type
                          </Typography>
                          <Select
                            value={uploadType}
                            // label="Upload Type"
                            onChange={(e) => setUploadType(e.target.value)}
                          >
                            <MenuItem value="AddEmployee">
                              Add Employee
                            </MenuItem>
                            <MenuItem value="UpdateEmployee">
                              Update Employee
                            </MenuItem>
                            <MenuItem value="ActivateDeactivate">
                              Activate & Deactivate
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>
                    <Grid item size={{ xs: 12, md: 6 }}>
                      <CustomExcelUpload
                        values={values}
                        setFieldValue={setFieldValue}
                        resetForm={resetForm}
                      />

                      <Typography
                        onClick={handleSamplDownload}
                        variant="body1"
                        sx={{
                          cursor: "pointer",
                          color: "var(--main-color)",
                        }}
                      >
                        Download & Sample Excel Format
                      </Typography>
                      {/* </a> */}
                    </Grid>
                  </>
                ) : (
                  <>
                    <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                      <CustomInputForm
                        name="employeeid"
                        label="Employee ID"
                        custPlaceholder="Enter Employee ID "
                        inputType="number"
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                      <CustomInputForm
                        name="employeename"
                        label="Employee Name"
                        custPlaceholder="Enter Employee Name"
                        inputType="text"
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                      <CustomDateInput name="dateofjoining" label="DOJ" />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                      <CustomDropdownMui
                        name="department"
                        label="Department"
                        custPlaceholder="-- Select Department --"
                        options={departmentOptions}
                        onChange={handleDepartmentChange}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                      <CustomDropdownMui
                        name="subdepartment"
                        label="Sub Department"
                        custPlaceholder="-- Select Sub Department --"
                        options={subDepartmentNames}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                      <CustomDropdownMui
                        name="designation"
                        label="Designation"
                        custPlaceholder="-- Select Designation --"
                        options={designationOptions}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                      <CustomDropdownMui
                        name="reportingmanager"
                        label="Reporting Manager"
                        custPlaceholder="-- Select Reporting Manager --"
                        options={managerOptions}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                      <CustomDropdownMui
                        name="reviewer"
                        label="Reviewer"
                        custPlaceholder="-- Select Reviewer --"
                        options={managerOptions}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                      <CustomDropdownMui
                        name="roleofkrkpi"
                        label="Role of KRA & KPI"
                        custPlaceholder="-- Select Role of KRA & KPI --"
                        options={roleofkrkpiOptions}
                      />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                      <CustomInputForm
                        name="password"
                        label="Password (Default)"
                        custPlaceholder="Enter Password"
                        type="password"
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                      <CustomInputForm
                        name="email"
                        label="Email"
                        custPlaceholder="Enter Email"
                        inputType="email"
                      />
                    </Grid>
                  </>
                )}

                {/* {!showExcelUpload && ( */}
                <Grid item size={{ xs: 12 }} sx={{ mt: 3 }}>
                  <Button
                    type="submit"
                    variant="contained"
                    sx={{
                      background: "var(--main-color)",
                      textTransform: "none",
                    }}
                  >
                    {editData?.employee_id ? "Update" : "Submit"}
                  </Button>
                </Grid>
                {/* )} */}
              </Grid>
            </Form>
          )}
        </Formik>
      </Box>
      <Box
        sx={{
          background: "white",
          p: 3,
          mt: 6,
          // maxWidth: "950px"
        }}
      >
        <Grid container spacing={2}>
          <Grid item size={{ xs: 12 }} sx={{ width: "100px", flex: 1 }}>
            <CustomTable
              tableHeadData={tableHeadData}
              tableData={rowTableData}
              title="Employee Details List"
              tableEdit={true}
              tableActions={true}
              tableSearch={true}
              tableActivate={true}
              handleTableEdit={handleTableEdit}
              handleActivateAndDeactivate={handleActivateAndDeactivate}
              handleRequestReapplyReject={handleRequestReapplyReject}
              handleRequestReapplyAccept={handleRequestReapplyAccept}
            />
          </Grid>
        </Grid>
      </Box>
      <ToastContainer
        position="top-right"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
      <InvalidRowsModal
        name="employee"
        open={invalidRowsModalopen}
        onClose={handleInvalidRowsModalClose}
        data={invalidRwModalResponseData}
      />
    </Box>
  );
};

export default AddEmployee;
